

class CreativeService {
    constructor(SERVICE_LOCATIONS, $http, $q, $rootScope) {
        return {

            previewAdunit: (adunit, campaignId) => {
                let deferred = $q.defer();
                var url = SERVICE_LOCATIONS.CPM_API + 'creative/preview';
                if(!!campaignId) {
                    url += "?campaignId=" + campaignId + "&";
                }
                else {
                    url += "?";
                }
                url += 'x=' + new Date().getTime();
                $http.put(url, adunit, {errorMessage: 'Failed to generate the preview.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            previewWithModel: (campaignId, creativeId, model) => {

                let deferred = $q.defer();

                let url = SERVICE_LOCATIONS.CPM_API + "creative/preview-with-model?campaignId=" + campaignId + "&creativeId=" + creativeId;
                url += "&x=" + new Date().getTime();

                $http.put(url, model, {errorMessage: 'Failed to generate the preview.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });

                return deferred.promise;

            },

            savePresets: (creativeId, presets) => {
                let deferred = $q.defer();
                $http.put(SERVICE_LOCATIONS.CPM_API + 'creative/' + creativeId + '/presets', { presets: presets }, {errorMessage: 'Failed to save presets.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },


            getTagMarkup: function(adunitId, debug) {

                var url = "//powered-by.reflow.tv/ad/tag.txt?&ad=" + adunitId;

                if("undefined" !== typeof debug && debug != null) {
                    url += "&d=" + (debug ? "1" : "0");
                }

                let deferred = $q.defer();

                $http.get(url)
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            getFileList: function(creativeId) {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + 'creative/' + creativeId + '/files', {errorMessage: 'Failed to load creative files.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            getFile: function(creativeId, filename) {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + 'creative/' + creativeId + '/file?name=' + encodeURIComponent(filename), {errorMessage: 'Failed to load creative file.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            saveFile: function(creativeId, filename, data) {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + 'creative/' + creativeId + '/file?name=' + encodeURIComponent(filename), data, {errorMessage: 'Failed to save creative file.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            exportToUAS: function(creativeId) {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + 'creative/' + creativeId + '/uas/export', null, {errorMessage: 'UAS export failed.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                    });
                return deferred.promise;
            },

            downloadForUas: function(data) {
                let deferred = $q.defer();

                $http.post(SERVICE_LOCATIONS.CPM_API + 'creative/uas/download', data, {responseType: "arraybuffer", errorMessage: 'There was an error with one or more creatives.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                    });
                    
                return deferred.promise;
            },

            downloadHTMLBundle: function(creativeId, data) {
                let deferred = $q.defer();

                $http.post(SERVICE_LOCATIONS.CPM_API + 'creative/' + creativeId + "/export/bundle", data, {responseType: "arraybuffer", errorMessage: 'Error generating bundle.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                    });
                    
                return deferred.promise;
            },

            generateHtmlExportConfig: function(data) {
                if (!data) {
                    return
                }

                let deferred = $q.defer();

                $http.post(SERVICE_LOCATIONS.CPM_API + 'creative/export/bundle/configuration/initial', data, {errorMessage: 'Error generating bundle.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                    });
                    
                return deferred.promise;
            }

        };
    }

}

angular.module('cpm')
    .service('CreativeService', ['SERVICE_LOCATIONS', '$http', '$q', '$rootScope', CreativeService]);
